import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';

import { getMapDiv, setupMapServices, getLocation } from '../../reducers/mapRefs';
import { getMap, resetMapView, goToLocation } from '../../utils/map-google/mapUtils';
import MapLayer from './MapLayer';

const useStyles = makeStyles((theme) => ({
  mapWrapper: {
    width: '100%',
    height: 'calc(100vh - 64px)',
    [theme.breakpoints.down('xs')]: {
      height: 'calc(100vh - 56px)',
    },
  },
}));

const MapPanel = ({ height }) => {
  const mapDiv = useSelector(getMapDiv);
  const dispatch = useDispatch();
  const classes = useStyles({ height });

  // reset map view when unmounting map
  useEffect(() => resetMapView, []);

  // init map on first mount, otherwise append mapDiv to component div
  useEffect(() => {
    if (!mapDiv) {
      dispatch(setupMapServices());
    } else {
      mapDiv.style.display = 'block';
      mapDiv.style.height = '100%';
      document.getElementById('map-wrapper').appendChild(mapDiv);
      const map = getMap();
      if (map.someLeafletProp) map.invalidateSize();
    }
    return () => {
      if (mapDiv?.style?.display) mapDiv.style.display = 'none';
      // cleanup height property from above
      if (mapDiv?.style?.height) mapDiv.style.height = null;
    };
  }, [mapDiv, setupMapServices]);

  const location = useSelector(getLocation);

  useEffect(() => {
    if (location) {
      const map = getMap();

      if (map) {
        goToLocation(location);
      }
    }
  }, [location]);

  return (
    <>
      <div id="map-wrapper" className={classes.mapWrapper} />
      <MapLayer />
    </>
  );
};

export default MapPanel;
